import { createAction } from '@reduxjs/toolkit';
import type { AxiosResponse } from 'axios';

// Import store actions
import { PARENTAL_CONTROL_LOADING, PARENTAL_CONTROL_SUCCESS, PARENTAL_CONTROL_ERROR } from 'store/actions/types';

// Import types
import type { ApiErrorData } from 'types/api/errors';
import type { ParentalControlResponse } from 'types/api/subscriber';

export const parentalControlLoading = createAction<boolean>(PARENTAL_CONTROL_LOADING);
export const parentalControlSuccess = createAction<ParentalControlResponse>(PARENTAL_CONTROL_SUCCESS);
export const parentalControlError = createAction<AxiosResponse<ApiErrorData>>(PARENTAL_CONTROL_ERROR);
